import {CommonModule} from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {LaRoundButtonComponent} from './la-round-button.component';
import {LaTextModule} from '../text/la-text.module';
import {LaColorService} from '../colors/la-color.service';

// Export module's public API

@NgModule({
  imports: [
    CommonModule,
    LaTextModule.forRoot()
  ],
  exports: [LaRoundButtonComponent],
  declarations: [LaRoundButtonComponent],
  providers: [LaColorService]
})
export class LaRoundButtonModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaRoundButtonModule,
      providers: [LaColorService]
    };
  }
}
